import { render, staticRenderFns } from "./addmoreteacher.vue?vue&type=template&id=2b2b2a60"
import script from "./addmoreteacher.ts?vue&type=script&lang=js&external"
export * from "./addmoreteacher.ts?vue&type=script&lang=js&external"
import style0 from "./addmoreteacher.vue?vue&type=style&index=0&id=2b2b2a60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports